/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseFileSearchCallCompletedEvent = {
  type: "response.file_search_call.completed";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
};

/** @internal */
export const ResponseFileSearchCallCompletedEvent$inboundSchema: z.ZodType<
  ResponseFileSearchCallCompletedEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.file_search_call.completed"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseFileSearchCallCompletedEvent$Outbound = {
  type: "response.file_search_call.completed";
  sequence_number: number;
  item_id: string;
  output_index: number;
};

/** @internal */
export const ResponseFileSearchCallCompletedEvent$outboundSchema: z.ZodType<
  ResponseFileSearchCallCompletedEvent$Outbound,
  z.ZodTypeDef,
  ResponseFileSearchCallCompletedEvent
> = z.object({
  type: z.literal("response.file_search_call.completed"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseFileSearchCallCompletedEventToJSON(
  responseFileSearchCallCompletedEvent: ResponseFileSearchCallCompletedEvent,
): string {
  return JSON.stringify(
    ResponseFileSearchCallCompletedEvent$outboundSchema.parse(
      responseFileSearchCallCompletedEvent,
    ),
  );
}
export function responseFileSearchCallCompletedEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseFileSearchCallCompletedEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseFileSearchCallCompletedEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseFileSearchCallCompletedEvent' from JSON`,
  );
}
